import { combineReducers } from 'redux'
import { websiteSettingsReducer } from 'src/publisher/store/website-settings/website-settings-reducer'
import blog from './blogReducer'
import files from './filesReducer'
import lecture from './lectureReducer'
import management from './managementReducer'
import offerThankYou from './offerThankYouReducer'
import optIn from './optInReducer'
import page from './pageReducer'
import payment from './paymentReducer'
import webinar from './webinarReducer'
import webinarSession from './webinarSession'

const rootReducer = combineReducers({
  page,
  files,
  management,
  optIn,
  webinar,
  webinarSession,
  payment,
  offerThankYou,
  lecture,
  blog,
  websiteSettings: websiteSettingsReducer,
})

export default rootReducer
